module.exports = {
    appId: 'e9e51e04-5c7d-48f4-91b0-df48601b971f',
    //redirectUri: 'http://localhost:3000',
    redirectUri: 'https://vfxweb.ipfx.com/admin/bookit/graph_api',
    scopes: [
      'user.read',
      'Files.ReadWrite.All'
    ]
};